var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cm-activation-popup'),_vm._v(" "),_c('cm-payments-popups')],1)}
var staticRenderFns = []

export { render, staticRenderFns }